import { useCallback } from 'react'

import { cn } from '@/lib/utils'

import { type FilterContentProps } from './filter-content'
import { FilterItem } from './filter-item'

export const FilterItems = (props: {
  disabled: boolean
  hideCount?: boolean
  items: FilterContentProps['items']
  values: FilterContentProps['values']
  onChange: (options: string[]) => void
}) => {
  const filterItems = props.items

  const handleChange = useCallback(
    (option: string) => {
      let options = []

      if (props.values?.includes(option)) {
        options = props.values.filter((t) => t !== option)
      } else {
        options = [...(props?.values ?? []), option]
      }

      props.onChange(options)
    },
    [props]
  )

  if (filterItems.length === 0) {
    return <div className={cn('mt-2 text-center text-sm text-muted-foreground')}>No items</div>
  }

  return (
    <div className={cn('flex flex-col gap-[1px]')}>
      {filterItems.map((x) => {
        return (
          <FilterItem
            key={x.filterValue}
            disabled={props.disabled}
            title={x.filterName}
            count={props.hideCount ? null : x.count}
            checked={props.values?.includes(x.filterValue)}
            onClick={() => handleChange(x.filterValue)}
          />
        )
      })}
    </div>
  )
}
